var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"header-box"},[_c('div',{staticClass:"header-mid"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/Image/logopc.png"}})]),_c('ins-menu')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }